module.exports = ".box-div{background-color:#f5f5f5;margin-bottom:10px;box-sizing:content-box}\n"